import type {
  ReplacementOrderRequest,
  ReplacementOrderResult,
} from "@/services/replacement-order/replacement-order.types";
import type { ReplacementOrderService } from "@/services/replacement-order/replacement-order-service";
import { resolveScenario } from "./scenarios";

export const SCENARIO_QUERY_PARAM = "orderScenario";

const wait = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

const activeScenarioId = (): string =>
  new URLSearchParams(window.location.search).get(SCENARIO_QUERY_PARAM) ?? "";

export class MockReplacementOrderService implements ReplacementOrderService {
  public async submit(_request: ReplacementOrderRequest): Promise<ReplacementOrderResult> {
    const scenario = resolveScenario(activeScenarioId());
    await wait(scenario.latencyMs);
    if (scenario.shouldFail) {
      throw new Error(`Simulated replacement-order submit failure (scenario: ${scenario.id})`);
    }
    return scenario.result;
  }
}
